import React from 'react';
import { Navigate } from 'react-router-dom';

function PrivateRoute({ currentUser, loading, children }) {
  if (loading) {
    return <div className="loading">Loading...</div>;
  }
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

export default PrivateRoute;
